import { TransactionDirections, TransactionStatuses } from 'mmfintech-backend-api'
import type { TransactionViewPortal } from 'mmfintech-backend-api/types'

/** A card payment is shown in the card's own amount and currency, not the settled one. */
export function getTransactionDisplayAmount(transaction: TransactionViewPortal) {
  const { amount, currency, cardPaymentDetails } = transaction || {}
  const { transactionAmount, transactionCurrency } = cardPaymentDetails || {}

  return transactionAmount
    ? { amount: transactionAmount, currency: transactionCurrency }
    : { amount, currency }
}

/** `−` for outgoing, `+` for incoming money that actually arrived; a failed deposit gets no sign. */
export function getTransactionAmountSign(direction?: string, status?: string) {
  if (direction === TransactionDirections.WITHDRAW) return '−'
  if (direction === TransactionDirections.DEPOSIT && status !== TransactionStatuses.FAILED) return '+'
  return ''
}
